import React, { ReactNode } from "react";
import { Button } from "components/DesignSystem/Button/Button";
import { PlusIcon } from "components/icons/PlusIcon";

export const NoAuthorisedPersonaTypeExist = ({
  ctaText,
  title,
  description,
  handleAdd,
  handleConfirm,
  confirmCtaText,
  icon,
  readOnly = false,
}: {
  ctaText?: string;
  title: string | ReactNode;
  description: string | ReactNode;
  handleAdd?: () => void;
  handleConfirm?: () => void;
  confirmCtaText?: string;
  icon?: ReactNode;
  readOnly?: boolean;
}) => {
  return (
    <div className="t-pb-[42px] t-pt-[42px] t-flex t-flex-col t-items-center t-justify-center t-rounded t-bg-surface-lighter-grey">
      <span className="t-text-neutral-30">{icon}</span>
      <div className="t-mt-3 t-mb-1 t-text-subtext-sm t-text-center">
        {title}
      </div>
      <div
        className={`t-text-subtext-sm t-text-text-30 t-text-center ${
          readOnly ? "" : "t-mb-4"
        }`}
      >
        {description}
      </div>
      {!readOnly && (
        <div className="t-flex t-items-center t-gap-2">
          <Button customType="link_neutral" size="small" onClick={handleAdd}>
            <PlusIcon size="14" /> &nbsp;
            {ctaText}
          </Button>
          <Button customType="secondary" size="small" onClick={handleConfirm}>
            {confirmCtaText}
          </Button>
        </div>
      )}
    </div>
  );
};
